import { Grid } from "@mui/material";
import { isNil } from "lodash";
import { useState } from "react";
import BaseTextField from "../../../core/components/base/BaseTextField";
import { OotTrickLinkDto } from "../OotTricksDtos";
import { CreateOotTrickDto } from "../OotTricksQuery";
import { OotTrickDifficultyAutocomplete } from "../autocomplete/OotTrickDifficultyAutocomplete";

interface CreateTrickLinkProps {
    index: number,
    values: CreateOotTrickDto,
    updateTrick: (value: OotTrickLinkDto, index: number) => void
}

const CreateTrickLink = (props: CreateTrickLinkProps) => {

    let [trick, setTrick] = useState<OotTrickLinkDto>(props.values?.links?.[props.index] ?? {} as OotTrickLinkDto)

    return <Grid container item xs={12} justifyContent={"space-between"}>
        <Grid item xs={3}>
            <BaseTextField label="Name" value={trick.name} onChange={(e) => {
                setTrick({ ...trick, name: e.currentTarget.value })
                props.updateTrick(trick, props.index);
            }} />
        </Grid>
        <Grid item xs={3}>
            <BaseTextField label="Url" value={trick.url} onChange={(e) => {
                setTrick({ ...trick, url: e.currentTarget.value })
                props.updateTrick(trick, props.index);
            }} />
        </Grid>
        <Grid item xs={3}>
            <OotTrickDifficultyAutocomplete label="Difficulty" selection={trick.difficulty} additionalOnChange={(e) => {
                if (!isNil(e)) {
                    setTrick({ ...trick, difficulty: e })
                    props.updateTrick(trick, props.index);

                    console.log(e);
                }
            }} />
        </Grid>
    </Grid>
}

export default CreateTrickLink